/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { MenuManagerItemDto } from '../models/MenuManagerItemDto.ts';
import type { ToZod } from '@kubb/plugin-zod/utils';
import { z } from 'zod';

export const menuManagerItemDtoSchema = z.object({
  id: z.coerce.number().int().optional(),
  title: z.coerce.string(),
  href: z.coerce.string().nullable().nullish(),
  visible: z.boolean().optional(),
  roles: z
    .array(
      z.enum([
        'dipendente',
        'cliente',
        'amministratore',
        'utenteEvoluto',
        'consulente',
      ]),
    )
    .nullable()
    .nullish(),
  children: z
    .array(z.lazy(() => menuManagerItemDtoSchema))
    .nullable()
    .nullish(),
}) as unknown as ToZod<MenuManagerItemDto>;
